<template>
    <div>
        <van-nav-bar title='气象数据统计'  @click-left="back" left-arrow/>
        <div  style="position:absolute;top:46px;left:0;right:0;bottom:0;overflow:auto;background:#ededed">
            <van-cell title="查询维度:"  @click="isShowDimension = true" :value='search_time_name' is-link />
            <van-cell title="查询年份(单选):" v-show="isShowYearList" :value='search_year_name'  @click="isShowYear = true" is-link />
            <van-cell title="查询年份(多选):" v-show="!isShowYearList"  :value='search_year_more_name' @click="isShowYear_more = true" is-link />
            <van-cell title="查询月份:" v-show="isShowMonthList" :value='search_month_name'  @click="isShowMonth = true" is-link />
            <van-cell title="查询属性:" v-show="isShowAttrList" :value='param_name'  @click="isShowAttribute = true" is-link /> 
            <van-cell title="查询属性(高阶):" v-show="!isShowAttrList" :value='param_name'  @click="isShowAttribute_more = true" is-link /> 
            <div ref="dom" style="height: 430px;position: relative !important;text-align:center;" v-show="showChar"></div>
            <div v-show="noData" style="height: 310px;position: relative !important;text-align:center;">暂无数据</div>
        </div>


         <!-- 选择维度 -->
            <van-popup v-model="isShowDimension" get-container="body">
                <van-radio-group v-model="search_time" style="width:200px">
                    <van-cell-group>
                        <van-cell v-for="(item,index) in dimensionList" :key="index" :title="item.name" clickable @click="changeDimension(item)">
                            <van-radio slot="right-icon" :name="item.value" />
                        </van-cell>                    
                    </van-cell-group>
                </van-radio-group>
            </van-popup>

            <!-- 选择年份(单) -->
            <van-popup v-model="isShowYear" get-container="body">
                <van-radio-group v-model="search_year" style="width:200px">
                    <van-cell-group>
                        <van-cell v-for="(item,index) in yearList" :key="index" :title="item.label" clickable @click="changeYear(item)">
                            <van-radio slot="right-icon" :name="item.value" />
                        </van-cell>                    
                    </van-cell-group>
                </van-radio-group>
            </van-popup>

            <!-- 选择年份(多选) -->        
            <van-popup v-model="isShowYear_more" get-container="body" style="width:200px">
                <van-checkbox-group v-model="search_year_more" @change='changeYearMore'>
                    <van-cell-group>
                        <van-cell
                        v-for="(item, index) in yearList"
                        clickable
                        :key="index"
                        :title="item.label"
                        @click="yearToggle(index)"
                        >
                        <van-checkbox
                            :name="item.value"
                            ref="yearMoreList"
                            slot="right-icon"
                        />
                        </van-cell>
                    </van-cell-group>
                    </van-checkbox-group>
            </van-popup>

            <!-- 选择月份 -->
            <van-popup v-model="isShowMonth" get-container="body">
                <van-radio-group v-model="search_month" style="width:200px">
                    <van-cell-group>
                        <van-cell v-for="(item,index) in monthList" :key="index" :title="item.label" clickable @click="changeMonth(item)">
                            <van-radio slot="right-icon" :disabled='item.type' :name="item.value" />
                        </van-cell>                    
                    </van-cell-group>
                </van-radio-group>
            </van-popup>

            <!-- 查询属性 -->
            <van-popup v-model="isShowAttribute" get-container="body">
                <van-radio-group v-model="param" style="width:200px">
                    <van-cell-group>
                        <van-cell v-for="(item,index) in Attribute" :key="index" :title="item" clickable @click="changeAttribute(item,index)">
                            <van-radio slot="right-icon" :disabled='item.type' :name="index" />
                        </van-cell>                    
                    </van-cell-group>
                </van-radio-group>
            </van-popup>

            <!-- 查询属性(高阶) -->
            <van-popup v-model="isShowAttribute_more" get-container="body">
                <van-radio-group v-model="param" style="width:200px">
                    <van-cell-group>
                        <van-cell v-for="(item,index) in attributeList" :key="index" :title="item" clickable @click="changeAttribute(item,index)">
                            <van-radio slot="right-icon" :disabled='item.type' :name="index" />
                        </van-cell>                    
                    </van-cell-group>
                </van-radio-group>
            </van-popup>
            
    </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
import {getWeatherName,weatherCount} from '@/request/data'
import echarts from 'echarts'
import tdTheme from '../../components/charts/theme.json'
export default {
    name:'weatherCount',
    data() {
        return {
            isShowDimension:false,
            isShowYear:false,
            isShowYear_more:false,
            isShowMonth:false,
            isShowAttribute:false,
            isShowYearList:true,
            isShowMonthList:true,
            isShowAttrList:true,
            isShowAttribute_more:false,
            weatherUuid:'',
            dimensionList:[
                {value:1,name:'日'},
                {value:2,name:'月'},
                {value:3,name:'年'},
                {value:4,name:'高阶查询'},
            ],
            search_time:1,
            search_time_name:'日',
            search_year:'',
            search_year_name:'',
            search_year_more:[],
            search_year_more_name:'',
            search_month:0,
            search_month_name:'全年',
            weatherInfo:{
                weather_type:1,
                line:'',
                query_type:'',
                uuid:'',
                type_id:'',
                query_year:[],
                query_month:'',
            },
             DavisAttribute:[
                {name:'barometer'},
                {name:'temp_out_avg'},
                {name:'wind_avg'},
                {name:'wind_direction'},
                {name:'humi_out'},
                {name:'rain'},
                {name:'sra_avg'},
                {name:'uv_index_grade'},
                {name:'et'},
            ],
            advancedAttributeList:['年积温(°C)'],
            WeatherName:[],
            Name:[],
            Attribute:[],
            attributeList:[],
            Lines:[],
            Type_ids:[],
            param:'',
            param_name:'',
            dom: null,
            noData:false,
            showChar:false,
            option:{
                title: {
                    text: ''
                },
                tooltip: {
                    confine:true,//该属性为true让tooltip不会超过父标签而显示不全
                    trigger: 'axis',    
                                    
                },                
                dataZoom: [
                    {                        
                        type: 'slider',
                        xAxisIndex: [0],
                        filterMode: 'filter',
                        bottom:'10%'
                    },
                ],
                legend: {
                    data:[]
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '6%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        //saveAsImage: {},
                        magicType: {
                        type: ['line', 'bar'],
                            // show: false
                        },
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    type: 'value',
                },
                series: [],
            },
            option2:{
                title: {
                    text: ''
                },
                tooltip: {
                    confine:true,//该属性为true让tooltip不会超过父标签而显示不全
                    // trigger: 'axis'
                },
                legend: {
                    data:[]
                },          
                radar: {            
                    name: {
                        textStyle: {
                            color: '#fff',
                            backgroundColor: '#999',
                            borderRadius: 3,
                            padding: [3, 5]
                        }
                    },
                    indicator: [ ],
                    center: ['50%', '45%'],
                    radius: 120
                },          
                series: [],
            },
        }
    },
    computed: {
        ...mapState(['backIndex']),
        yearList(){
            let myDate = new Date();
            let tYear = myDate.getFullYear();
            this.search_year = tYear
            this.search_year_name = tYear + '年'
            let arr = []
            for (let i = 0; i < 10; i++) {
                let obj = {}
                obj.value = tYear - i
                obj.label = tYear - i + '年'
                arr.push(obj)
            }      
            return arr
        },
        monthList(){
            let arr = []
                if (this.search_time ==1) {
                    for (let i = 0; i < 13; i++) {
                        let obj = {}
                        if (i ==0 ) {
                            obj.value = i
                            obj.label = '全年'                           
                        }else{
                            obj.value = i
                            obj.label = i + '月'                            
                        }
                        arr.push(obj)
                    }
                    return arr                    
                }else if (this.search_time ==3) {
                    for (let i = 1; i < 13; i++) {
                        let obj = {}                        
                        obj.value = i
                        obj.label = i + '月'                                              
                        arr.push(obj)
                    }
                    return arr
                }                
            }    
    },
    mounted() {
        this.setIsBack(true)
        this.setBackIndex(4)
        this.weatherUuid = this.$route.query.uuid
        this.getWeatherName()
    },
    methods: {
        ...mapMutations(['setIsBack','setBackIndex']),
        changeDimension(item){//改变维度           
            this.param_name = this.Attribute[0]
            this.search_time = item.value
            this.search_time_name = item.name            
            this.isShowAttrList = true
            let arr =  this.yearList
            switch (this.search_time) {
                case 1:
                    this.isShowYearList = true
                    this.isShowMonthList = true
                    this.search_month = this.monthList[0].value
                    this.search_month_name = this.monthList[0].label
                    this.search_year =  this.yearList[0].value
                    this.search_year_name =  this.yearList[0].label
                    break;
                case 2:
                    this.isShowYearList = false
                    this.isShowMonthList = false                    
                    this.search_year_more = []
                    this.search_year_more = [arr[0].value,arr[1].value,arr[2].value]
                    this.search_year_more_name = `${arr[0].label},${arr[1].label},+1...`
                    break;
                case 3:
                    this.isShowYearList = false
                    this.isShowMonthList = true                    
                    this.search_month = this.monthList[0].value
                    this.search_month_name = this.monthList[0].label                   
                    this.search_year_more = []
                    this.search_year_more = [arr[0].value,arr[1].value,arr[2].value]
                    this.search_year_more_name = `${arr[0].label},${arr[1].label},+1...`                    
                    break;
                case 4:
                    this.isShowYearList = true
                    this.isShowMonthList = false
                    this.isShowAttrList = false
                    this.attributeList = this.advancedAttributeList
                    this.param = 0
                    this.param_name = this.advancedAttributeList[0]
                    this.search_year =  this.yearList[0].value
                    this.search_year_name =  this.yearList[0].label
                    break;
            
                default:
                    break;
            }
            this.getChart()
            this.isShowDimension = false

        },
        getWeatherName(){//获取用户绑定的气象站列表      
            let arr = []
            arr.weather_type = 1;            
            getWeatherName(arr).then(res=>{                
                if (res.data.code == 0) {
                    this.WeatherName = res.data.data
                    for (let i = 0; i < this.WeatherName.length; i++) {
                        if (this.WeatherName[i].uuid == this.weatherUuid) {
                            this.Name = this.WeatherName[i].uuid
                            this.weatherInfo.weather_type = this.WeatherName[i].type
                            console.log(this.WeatherName[i].uuid)
                            this.getNames(this.WeatherName[i].uuid)
                        }                        
                    }
                    
                }else{
                
                }
            }).catch(res=>{
            })
        },
        getNames(v){//获取属性
            let str = v + '';
            str = str.slice(0,1);
            this.Attribute = []
            this.Lines = []
            this.Type_ids = []
            for (let i = 0; i < this.WeatherName.length; i++) {
                if(this.WeatherName[i].uuid == v){
                for (let j = 0; j < this.WeatherName[i].names.length; j++) {
                    if(j == 0){//选中第一个属性
                    this.param = j;                    
                    this.param_name = this.WeatherName[i].names[j]+'('+this.WeatherName[i].units[j]+')'
                    }
                    if(this.WeatherName[i].names[j] != 0 ){
                    if(str!=6){//国产气象站
                        this.Lines.push('line'+(j+1))
                        this.Type_ids.push(this.WeatherName[i].type_ids[j])
                    }else{//戴维斯气象站
                        this.Lines.push(this.DavisAttribute[j].name)
                        this.Type_ids.push(0)
                    }
                    this.weatherInfo.weather_type = this.WeatherName[i].type
                    this.Attribute.push(this.WeatherName[i].names[j]+'('+this.WeatherName[i].units[j]+')')
                    }
                }
                }
            }
            this.Attribute = JSON.parse(JSON.stringify(this.Attribute))
            this.Type_ids = JSON.parse(JSON.stringify(this.Type_ids))
            this.getChart()
        },
        getChart: function () {//获得图表数据并展示
            this.spinShow = true
            this.option.series = [] 
            this.option.legend.data = []
            this.option.legend.bottom = '0'
            this.option.xAxis.data = []
        
            if (this.search_time == 1 || this.search_time == 4) {
                this.weatherInfo.query_year = []
                this.weatherInfo.query_year.push(this.search_year)              
            }else{
                console.log(this.search_year)
                this.weatherInfo.query_year = this.search_year_more
            }                       
            this.weatherInfo.query_month = this.search_month            
            this.weatherInfo.query_type = this.search_time
            this.weatherInfo.uuid = this.Name
            if (this.search_time == 4) {
                this.weatherInfo.line = 'line1'            
            }else{
                this.weatherInfo.line = this.Lines[this.param]              
            }
            this.weatherInfo.type_id = this.Type_ids[this.param]            
            this.getWeatherCount(this.weatherInfo)          
        },
        getWeatherCount(data){            
            weatherCount(data).then(res=>{       
                console.log(res)         
                this.noData = false
                this.showChar = true
                // this.showChar2 = true
                this.spinShow =false
                if (res.data.code == 0) {
                    if (this.Type_ids[this.param] == 101 || data.line == "wind_direction") {
                        this.addRadar(res.data)
                    }else{
                        if (!this.isShowAttributeList) {
                            this.option.title.text = this.Attribute[this.param].split('(')[0]+'统计';                    
                        }else{
                            this.option.title.text = this.attributeList[this.param].split('(')[0]+'统计';
                        }               
                        this.option.series = this.getSeries(JSON.parse(JSON.stringify(res.data.data.weather)),JSON.parse(JSON.stringify(res.data.data.name))) 
                        this.option.legend.data = JSON.parse(JSON.stringify(res.data.data.name))
                        this.option.xAxis.data = JSON.parse(JSON.stringify(res.data.data.time))
                        if (this.search_time == '3') {//年维度柱状
                            this.option.toolbox.feature.magicType.type = 'bar'
                        }else{
                            this.option.toolbox.feature.magicType.type = ['line', 'bar']
                        }                        
                        this.$nextTick(()=>{
                            this.dom = echarts.init(this.$refs.dom,'tdTheme');
                            this.dom.setOption(this.option,true);
                            
                        })
                    }
                
                }else{
                    this.noData = true
                    this.showChar = false            
                }
            }).catch(res=>{
            })



        },
        addRadar(info){
            if (this.search_time == '2') {
                this.option.series = this.getSeries(JSON.parse(JSON.stringify(info.data.weather)),JSON.parse(JSON.stringify(info.data.name))) 
                this.option.legend.data = JSON.parse(JSON.stringify(info.data.name))
                this.option.legend.bottom = '0'
                this.option.xAxis.data = JSON.parse(JSON.stringify(info.data.time))       
                this.$nextTick(()=>{
                    this.dom = echarts.init(this.$refs.dom,'tdTheme');
                    this.dom.setOption(this.option,true);
                    
                })
                
            }else{
                this.option2.title.text = '风向雷达图'
                this.option2.legend.bottom = '0'
                let obj = {}
                let indicator = []
                obj.type = 'radar'
                obj.data = []
                
                for (let i = 0; i < info.data.weather.length; i++) {
                    let oobj = {}
                    oobj.value = info.data.weather[i]
                    if (typeof(info.data.name) == 'string') {
                        oobj.name = info.data.name
                    }else{
                        oobj.name = info.data.name[i]
                    }
                    obj.data.push(oobj)            
                }
                //循环风向
                for (let j = 0; j < info.data.explain.length; j++) {
                    let oobj2 = {}
                    oobj2.name =  info.data.explain[j]
                    if (this.search_time == 3) {
                    oobj2.max = 30
                    }else{
                    oobj2.max = 200
                    }
                    indicator.push(oobj2)
                }
                
                    
                
                this.option2.series = []
                this.option2.series.push(obj)
                if (this.search_time == 3) {
                    this.option2.legend.data = info.data.name
                }else{
                    this.option2.legend.data = [info.data.name]
                }
                
                this.option2.radar.indicator = indicator
                
                this.$nextTick(()=>{
                    this.dom = echarts.init(this.$refs.dom,'tdTheme');
                    this.dom.setOption(this.option2,true);
                    
                })
            }
        },
        getSeries(seriesData,legendData){//处理图表数据      
            var series=[];
            for(var i = 0;i<legendData.length;i++){
                let t ='line'
                let w = ''
                if (this.search_time == 3) {
                t = 'bar'
                w = 20
                }
                series.push({
                name: legendData[i],
                type: t,
                barWidth: w,
                data: seriesData[i]
                });
            }            
            return series;
        },
        changeYear(item){//改变年份
            this.search_year = item.value
            this.search_year_name = item.label
            this.isShowYear = false
            this.getChart()            
        },
        changeYearMore(item){
            console.log(item.length,this.search_year_more_name)
            this.search_year_more_name = ''
            if (item.length > 2) {
                this.search_year_more_name = `${item[0]}年,${item[1]}年,+${item.length-2}...`
            }else{
                switch (item.length) {
                    case 0:
                        this.search_year_more_name = ''
                        break;
                    case 1:
                        this.search_year_more_name = item[0]
                        break;
                    case 2:
                        this.search_year_more_name = `${item[0]},${item[1]}`
                        break;                
                    default:
                        break;
                }
                //  
            }
            this.getChart()
        },
        changeMonth(item){    
            console.log(item)
            this.search_month = item.value
            this.search_month_name = item.label
            this.isShowMonth = false
            this.getChart()
        },
        changeAttribute(item,index){
            console.log(item,index)
            this.param = index
            this.param_name = item
            this.isShowAttribute = false
            this.isShowAttribute_more = false
            this.getChart()
        },
        yearToggle(index){            
            this.$refs.yearMoreList[index].toggle();
        },        
        back(){
            this.$router.go(-1)
        },
    },
}
</script>

<style  scoped>

</style>